query CorporateWorkgroupCommonData {
  companyBusinessUnits(
    orderBy: NAME_ASC
    filter: {_isProductionBusinessUnit: {equalTo: false}}
  ) {
    nodes {
      id
      name
      chartOfAccountId
    }
  }
  productionStatuses(orderBy: ID_ASC) {
    nodes {
      id
      statusType
    }
  }
  corporateChartOfAccounts(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  productionPhases(orderBy: STATUS_TYPE_ASC) {
    nodes {
      id
      statusType
    }
  }
}
